var _path, _rect, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrchestra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 199,
    viewBox: "0 0 132 199",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0045 197.369H6.99775C3.68446 197.369 1 194.683 1 191.369V186.909V175.449V169.917V165.317C1 163.856 1.40017 162.423 2.1571 161.173L3.67202 158.671C4.42894 157.421 4.82911 155.988 4.82911 154.527V152.74H49.4747V154.235C49.4747 155.905 49.9973 157.533 50.9693 158.891L52.5054 161.037C53.4774 162.395 54 164.023 54 165.693V169.917V177.03V182.562V188.094V191.369C54 194.683 51.3173 197.369 48.0045 197.369Z",
    fill: "#E0E4FD",
    stroke: "#AFB4FF",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 149.369,
    width: 54.2361,
    height: 3.95161,
    rx: 1.97581,
    fill: "#AFB5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52783 166.756L4.52129 167.467C10.2417 168.827 16.1521 169.201 21.9982 168.573L22.6463 168.503C26.1254 168.13 29.6358 168.154 33.1094 168.576L33.5825 168.634C38.418 169.222 43.318 168.987 48.0754 167.941L54.2362 166.756V191.788C54.2362 194.549 51.9976 196.788 49.2362 196.788H6.52783C3.7664 196.788 1.52783 194.549 1.52783 191.788V166.756Z",
    fill: "#AFB5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0844 103.782L33 130.26L62.1309 115.439L52.1392 115.03L69.3296 110.73L89.3162 87.0279L68.211 89.1661L97.7187 77.3637L103.013 58.0641L90.5233 57.5526L110.641 42.8636L119.535 21.2093L131.242 4.17412L94.7603 15.1905L87.7543 27.4141L88.0612 19.9204L70.523 32.7134L64.7906 50.4938L61.6823 40.8585L48.6898 64.8469L48.0351 80.8335L41.7656 75.0722L38.7358 87.959L37.7656 99.4289L37.4792 106.423L34.0844 103.782Z",
    fill: "#AFB5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1775 126.091L93.8806 36.6725L59.5664 80.3049L34.0401 129.301L41.1775 126.091Z",
    fill: "#9889B6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0001 130.369L52.5266 92.3796C55.2112 87.1566 58.3695 82.1909 61.9616 77.545L101.825 25.9886",
    stroke: "#343FC8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4855 129.369L33.4037 129.515C29.8272 135.939 27.0405 142.771 25.1044 149.863V149.863",
    stroke: "#343FC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchestra);
export default __webpack_public_path__ + "static/media/orchestra.047d50ed1313c7444062e4daf133aa2c.svg";
export { ForwardRef as ReactComponent };